import { Controller } from "@hotwired/stimulus"

// The new-group form keeps MCP and Hudini in one form, so turning MCP off has
// to lock Hudini in the browser. The Access tab auto-submits MCP and replaces
// the Hudini switch from the server; this controller only keeps an unsaved
// form in sync and must not overwrite the Hudini value that will be submitted.
export default class extends Controller {
  static targets = ["mcp", "hudini"]
  static values = { aiLocked: { type: Boolean, default: false } }

  connect() {
    this.onMcpChange = () => this.sync()
    this.mcpCheckbox?.addEventListener("change", this.onMcpChange)
  }

  disconnect() {
    this.mcpCheckbox?.removeEventListener("change", this.onMcpChange)
  }

  sync() {
    if (this.aiLockedValue || !this.hudiniCheckbox || !this.mcpCheckbox) return

    if (this.mcpCheckbox.checked) {
      this.restoreHudini()
    } else {
      this.lockHudiniOff()
    }
  }

  // Inverted switch: checked submits "0" (access kept). Remember that value,
  // then show Hudini off and disabled. The hidden field keeps submitting the
  // remembered value because a disabled checkbox is omitted from the form.
  lockHudiniOff() {
    const checkbox = this.hudiniCheckbox
    if (!this.hudiniTarget.dataset.storedValue) {
      this.hudiniTarget.dataset.storedValue = checkbox.checked ? "0" : "1"
    }

    checkbox.checked = false
    checkbox.disabled = true

    const hidden = this.hudiniHidden
    if (!hidden) return

    hidden.disabled = false
    hidden.value = this.hudiniTarget.dataset.storedValue
  }

  restoreHudini() {
    const checkbox = this.hudiniCheckbox
    const stored = this.hudiniTarget.dataset.storedValue

    checkbox.disabled = false
    if (stored) checkbox.checked = stored === "0"
    delete this.hudiniTarget.dataset.storedValue

    const hidden = this.hudiniHidden
    if (!hidden) return

    hidden.disabled = false
    hidden.value = "1"
  }

  get mcpCheckbox() {
    return this.hasMcpTarget ? this.mcpTarget.querySelector("input[type='checkbox']") : null
  }

  get hudiniCheckbox() {
    return this.hasHudiniTarget ? this.hudiniTarget.querySelector("input[type='checkbox']") : null
  }

  get hudiniHidden() {
    return this.hudiniTarget.querySelector("input[type='hidden']")
  }
}
